import { HiDialog } from '@/js/common/HINotificationSupport';
import { callGetConfigurationParameters } from '@/js/services/APIErp';
import { useAppConfigStore } from '@/js/stores/appConfig';
import { logError } from '@/js/utils/log';
import { initConfigurationParams } from '@erpagroapp/params';
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';

export function useLoadConfigurationParameters() {
  const {
    availableModuleIds,
    availableProcessIds,
  } = storeToRefs(useAppConfigStore());
  const { t } = useI18n();

  async function loadConfigurationParameters() {
    HiDialog.Preloader(true, t('login.info.loadingConfigurationParameters'), false);

    try {
      await initConfigurationParams(
        availableModuleIds.value,
        availableProcessIds.value,
        callGetConfigurationParameters,
      );
    } catch (error) {
      logError(error);
    }

    HiDialog.Preloader(false);
  }

  return {
    loadConfigurationParameters,
  };
}
